import Map from './components/map';
import { useState, useEffect, useRef } from 'react';
import FallbackHeader from './components/fallback-header';
import StateDropdown from './components/state-dropdown';
import StateHtml from './components/html/state';
import { Page } from './components/page';
import useMediaQuery from './helper/useMediaQuery';
import { tablet } from './helper/screensizes';

const App = () => {
  const [selectedState, setSelectedState] = useState<string>('');
  const [isTablet] = useMediaQuery(tablet);

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element: any = ref.current;
    const state = selectedState?.replace(' ', '_');
    if (state && element) {
      const stateEl = element.querySelectorAll(`#${state}`)[0];
      if (stateEl) {
        // scroll smooth do not work in mobile. Set scroll to true to allow scrolling.
        const scrollAnimation = isTablet ? { behavior: 'smooth' } : true;
        stateEl.scrollIntoView(scrollAnimation);
        setSelectedState('');
      }
    }
  }, [selectedState, isTablet]);

  return (
    <Page>
      <FallbackHeader />
      <StateDropdown selectedState={selectedState} onSelectState={setSelectedState} />
      <Map selectLocation={setSelectedState} />
      <div ref={ref} dangerouslySetInnerHTML={{ __html: StateHtml }} />
    </Page>
  );
};

export default App;
